<template>
  <div>
    <table class="dep-table details-table" style="width: 100%; font-size: 13px; border-collapse: collapse;">
      <thead>
        <tr>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Sn</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Code</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Item</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Description</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Lot No.</th>
            <th style="border: 1px solid #E0E0E0; padding: 2px;">Unit</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Qty.</th>
          <th v-if="isFreeItem" style="border: 1px solid #E0E0E0; padding: 2px;">Free Qty.</th>
          
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Rate</th>
          <th style="border: 1px solid #E0E0E0; padding: 2px;">Amount</th>
        </tr>
      </thead>

      <tbody>

        <template v-for="(row, idx) in orderInvoice?.details" :key="idx">
          <tr>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ idx + 1 }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.code }}</td>
            <td style="border:1px solid #E0E0E0;">{{ row.product?.name }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.description }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.lot_no }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.product?.unit?.name }}</td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ row.quantity }}</td>
            <td v-if="isFreeItem" style="border:1px solid #E0E0E0; text-align:center;">{{ row.free_qty }}</td>
            <td style="border:1px solid #E0E0E0; text-align:right;">{{ row.sale_rate }}</td>
            <td style="border:1px solid #E0E0E0; text-align:right;">{{ row.total }}</td>
          </tr>

          <tr v-for="(gift, gIdx) in row.gifts || []"
            :key="gIdx">
            <td style="border:1px solid #E0E0E0; text-align:center;"></td>
            <td style="border:1px solid #E0E0E0; text-align:center;">{{ gift.product?.code }}</td>
            <td style="border:1px solid #E0E0E0; text-align:left;">
              🎁 {{ gift.product?.name }}
            </td>

            <td style="border:1px solid #E0E0E0; text-align:center;"></td>
            <td style="border:1px solid #E0E0E0; text-align:center;"></td>
            <td style="border:1px solid #E0E0E0; text-align:center;">
              {{ gift.product?.unit?.name }}
            </td>
            <td style="border:1px solid #E0E0E0; text-align:center;">
              {{ gift.quantity }}
            </td>

            <td style="border:1px solid #E0E0E0; text-align:center;">0</td>
            <td style="border:1px solid #E0E0E0; text-align:right;">{{ gift.sale_rate }}</td>
            <td style="border:1px solid #E0E0E0; text-align:right;">{{ gift.total }}</td>

          </tr>
        </template>

      </tbody>

      <tfoot>
        <tr>
          <td :colspan="isFreeItem?8:7" style="border: 1px solid #E0E0E0; padding: 2px; border-top: none !important;"></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; border-top: none !important; text-align:right;"><strong>SUBTOTAL</strong></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right; border-top: none !important;">{{ orderInvoice?.sub_total }}</td>
        </tr>
        <tr>
          <td :colspan="isFreeItem?8:7" style="border: 1px solid #E0E0E0; padding: 2px; border-top: none !important;"></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align:right;"><strong>DISCOUNT</strong></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ orderInvoice?.discount_amount }}</td>
        </tr>
        <tr>
          <td :colspan="isFreeItem?8:7" style="border: 1px solid #E0E0E0; padding: 2px; border-top: none !important;"></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-transform: capitalize; text-align:right;"><strong>VAT ({{ orderInvoice?.vat_type }})</strong></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ orderInvoice?.vat_amount > 0 ? orderInvoice?.vat_amount : '-' }}</td>
        </tr>
        <tr>
          <td :colspan="isFreeItem?8:7" style="border: 1px solid #E0E0E0; padding: 2px; border-top: none !important;"></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-transform: capitalize; text-align:right;"><strong>TAX ({{ orderInvoice?.tax_type }})</strong></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ orderInvoice?.tax_amount > 0 ? orderInvoice?.tax_amount : '-' }}</td>
        </tr>
        <tr>
          <td :colspan="isFreeItem?8:7" style="border: 1px solid #E0E0E0; padding: 2px; border-top: none !important;"></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align:right;"><strong>PAID</strong></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ orderInvoice?.paid }}</td>
        </tr>
        <tr>
          <td :colspan="isFreeItem?8:7" style="border: 1px solid #E0E0E0; padding: 2px; border-top: none !important;"></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align:right;"><strong>DUE</strong></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right;">{{ orderInvoice?.due }}</td>
        </tr>
        <tr style="background-color: #f0f0f0;">
          <td :colspan="isFreeItem?8:7" style="border: 1px solid #E0E0E0; padding: 2px; border-top: none !important;"></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; font-weight: bold; text-align:right;"><strong>TOTAL</strong></td>
          <td style="border: 1px solid #E0E0E0; padding: 2px; text-align: right; font-weight: bold;">{{ orderInvoice?.total }}</td>
        </tr>
        <tr>
          <td colspan="100%" style="">
            <div style= "display: flex; margin-top: 20px;">
              <p style="text-align: start;"><strong>In words: </strong></p>
              <p style="text-align: start;">{{ convertNumberToWords(orderInvoice?.sub_total) }}</p>
            </div>

            <div style= "display: flex; margin-top: 5px;">
              <p style="text-align: start;"><strong>Mode of payment: </strong></p>
              <p style="text-align: start;"> by A/C payee cheque in favour of "{{ orderInvoice?.branch?.company?.name }}"</p>
            </div>
                
<!--            <div style= "margin-top: 5px; background-color: #ffffff;">-->
<!--              <p><strong>Payment Terms: </strong></p>-->
<!--              <p>{{ orderInvoice?.payment_terms || '-' }}</p>-->
<!--            </div>-->
            <div v-if="orderInvoice?.payment_bank" style= "margin-top: 5px; background-color: #ffffff;">
              <p><strong>Wire Transfer to following bank account: </strong></p>
              <table style="border-collapse: collapse;">
                <tbody >
                  <tr>
                    <td style="border:none; width: 200px;">Account Name</td>
                    <td style="border:none;">:{{  orderInvoice?.payment_bank?.account_name? `${orderInvoice?.payment_bank?.account_name}`: ""  }}</td>
                  </tr>
                  <tr>
                    <td style="border:none;">Account Number</td>
                    <td style="border:none;">:{{ orderInvoice?.payment_bank?.account_no? `${orderInvoice?.payment_bank?.account_no}`: ""  }}</td>
                  </tr>
                  <tr>
                    <td style="border:none;">Name of the Bank</td>
                    <td style="border:none;">:{{ orderInvoice?.payment_bank?.name? `${orderInvoice?.payment_bank?.name}`: ""  }}</td>
                  </tr>
                  <tr>
                    <td style="border:none;">Branch Name</td>
                    <td style="border:none;">:{{ orderInvoice?.payment_bank?.branch? `${orderInvoice?.payment_bank?.branch}`: ""  }}</td>
                  </tr>
                  <tr>
                    <td style="border:none;">Swift Code</td>
                    <td style="border:none;">:{{ orderInvoice?.payment_bank?.swift_code? `${orderInvoice?.payment_bank?.swift_code}`: ""  }}</td>
                  </tr>
                  <tr>
                    <td style="border:none;">Routing No.</td>
                    <td style="border:none;">:{{ orderInvoice?.payment_bank?.routing_no? `${orderInvoice?.payment_bank?.routing_no}`: ""  }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import convertNumberToWords from '@/plugins/numberToWord';

export default {
  name: "slsSaleOrderDetailsTable",
  data() {
    return {
      orderInvoice: null,
      
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    convertNumberToWords,
  },
  setup(props, { emit }) { },
  
  mounted() {
    const id = this.$route.query.referenceable_id;
    this.$store.dispatch('getSaleOrderById', id)
      .then((res) => {
        this.orderInvoice = res;
      })
  },
};

</script>
